import { useMutation, useQuery } from "@apollo/client/react";
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import {
  Grid,
  Chip
} from
  '@mui/material';
import { useEffect, useMemo, useState } from 'react';
import toast from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';
import DataGridGenerico from '../../../components/dataGrid/DataGridGenerico';
import { generateColumnsDefaultConfiguration } from '../../../components/dataGrid/columnHelpers';
import EmptyGridSvg from '../../../assets/svg/EmptyGridInsumo.svg';
import { PopoverModal } from '../../../components/popoverModal/PopoverModal';
import { SelectInput } from '../../../components/selectInput/SelectInput';
import { SwitchInput } from '../../../components/switchInput/SwitchInput';
import { TextInput } from '../../../components/textInput/TextInput';
import { adaptDepositoArray } from '../../../adapters/proveedores/depositoAdapter';
import { adaptFrecuenciaModoDespachoArray } from '../../../adapters/frecuenciaDistribuidor/frecuenciaModoDespachoAdapter';
import { adaptTipoZonaArray } from '../../../adapters/frecuenciaDistribuidor/tipoZonaAdapter';
import { CREATE_FRECUENCIA_DISTRIBUIDOR } from '../../../data/graphQL/mutations/FrecuenciaDistribuidor/createFrecuenciaDistribuidor';
import { UPDATE_FRECUENCIA_DISTRIBUIDOR } from '../../../data/graphQL/mutations/FrecuenciaDistribuidor/updateFrecuenciaDistribuidor';
import { GET_ALL_DEPOSITO } from '../../../data/graphQL/queries/ProveedorDistribuidor/getAllDeposito';
import { GET_ALL_TIPO_ZONA } from '../../../data/graphQL/queries/FrecuenciaDistribuidor/getAllTipoZona';
import { GET_ALL_FRECUENCIA_MODO_DESPACHO } from '../../../data/graphQL/queries/FrecuenciaDistribuidor/getAllFrecuenciaModoDespacho';
import { BuscarProveedor } from './BuscarProveedor';
import { BuscarCodigoPostal } from './BuscarCodigoPostal';
import { FrecuenciaDetalleModal } from './FrecuenciaDetalleModal';
import { GET_ALL_CODIGO_POSTAL_WITH_OUT_FILTER } from '../../../data/graphQL/queries/FrecuenciaDistribuidor/getAllCodigoPostalWithOutFilter';

import { useLocation } from 'react-router-dom';
import './frecuenciaDistribuidorCreationContent.scss';
import { CustomButton } from '../../../components/customButton/CustomButton';
export const FrecuenciaDistribuidorCreationContent = ({ setChildrenAction, setHeaderContent, setFooterContent }) => {

  const [modalProveedorIsOpen, setModalProveedorIsOpen] = useState(false);
  const [modalCPIsOpen, setModalCPIsOpen] = useState(false);
  const [modalidadIsOpen, setModalidadIsOpen] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();
  const stateData = location.state;
  const editDataFormModel = stateData?.FrecuenciaDistribuidor;
  var isNew = Boolean(!editDataFormModel);

  const [depositos, setDepositos] = useState([]);
  const { data: dataDeposito } = useQuery(GET_ALL_DEPOSITO, {
    variables: {
      where: {
        or: [
          { regional: { eq: true } }]

      }
    }
  });

  useEffect(() => {
    if (!dataDeposito) return;
    const selectedDepositos = adaptDepositoArray(dataDeposito);
    setDepositos(selectedDepositos);
  }, [dataDeposito]);

  const [tiposZona, setTiposZona] = useState([]);
  const { data: dataTipoZona } = useQuery(GET_ALL_TIPO_ZONA);

  useEffect(() => {
    if (!dataTipoZona) return;
    const selectedTiposZona = adaptTipoZonaArray(dataTipoZona);
    setTiposZona(selectedTiposZona);
  }, [dataTipoZona]);

  const [modosDespacho, setModosDespacho] = useState([]);
  const { data: dataModoDespacho } = useQuery(GET_ALL_FRECUENCIA_MODO_DESPACHO);

  useEffect(() => {
    if (!dataModoDespacho) return;
    const selectedModosDespacho = adaptFrecuenciaModoDespachoArray(dataModoDespacho);
    setModosDespacho(selectedModosDespacho);
  }, [dataModoDespacho]);

  const [codigosPostal, setCodigosPostal] = useState([]);
  const { data: dataCodigoPostal } = useQuery(GET_ALL_CODIGO_POSTAL_WITH_OUT_FILTER);

  useEffect(() => {
    if (!dataCodigoPostal) return;
    setCodigosPostal(dataCodigoPostal.allCodigoPostalWithOutFilter);
  }, [dataCodigoPostal]);

  const initialFormModel = {
    idFrecuenciaDistribuidor: 0,
    idProveedorDistribuidor: 0,
    kilometroDestino: '',
    costoEntregaInmediata: '',
    idDeposito: 0,
    activo: editDataFormModel?.activo || false,
    idFrecuenciaModoDespacho: 0,
    rowsFrecuencias: [],
    listaFrecuenciaDistribuidorCPs: []
  };

  const [editRow, setEditRow] = useState({});

  const initialProveedor = {
    codigoSAP: ''
  };

  const initialCP = {
    idTipoZona: 0,
    cp: '',
    provincia: '',
    localidad: ''
  };

  const [dataFormModel, setDataFormModel] = useState(initialFormModel);
  const [dataFormProveedor, setDataFormProveedor] = useState(initialProveedor);
  const [dataFormCP, setDataFormCP] = useState(initialCP);
  const [isNewModalidad, setIsNewModalidad] = useState(true);

  useEffect(() => {

    if (!isNew) {
      setDataFormModel(editDataFormModel);

      setDataFormProveedor({
        ...dataFormProveedor,
        codigoSAP: editDataFormModel.codigoSAP
      });

      setDataFormCP({
        ...dataFormCP,
        idTipoZona: editDataFormModel.idTipoZona,
        cp: editDataFormModel.codigoPostal,
        provincia: editDataFormModel.provincia,
        localidad: editDataFormModel.localidad
      });
    }
  }, []);

  const [createFrecuenciaDistribuidor] = useMutation(CREATE_FRECUENCIA_DISTRIBUIDOR, {
    onCompleted: () => { navigate('/buscarFrecuenciaDistribuidor') }
  });

  const [updateFrecuenciaDistribuidor] = useMutation(UPDATE_FRECUENCIA_DISTRIBUIDOR, {
    onCompleted: () => { navigate('/buscarFrecuenciaDistribuidor') }
  });

  const handleClickCreate = (e) => {
    if (isValidForm()) {
      createFrecuenciaDistribuidor({
        variables: {
          idProveedorDistribuidor: dataFormModel?.idProveedorDistribuidor,
          kilometroDestino: parseInt(dataFormModel?.kilometroDestino),
          costoEntregaInmediata: parseFloat(dataFormModel?.costoEntregaInmediata),
          idDeposito: dataFormModel?.idDeposito,
          activo: dataFormModel?.activo,
          idFrecuenciaModoDespacho: dataFormModel?.idFrecuenciaModoDespacho,
          listaFrecuenciaDistribuidorDetalles: dataFormModel?.rowsFrecuencias,
          listaFrecuenciaDistribuidorCPs: dataFormModel?.listaFrecuenciaDistribuidorCPs
        }
      });
    }
  };

  const isValidForm = () => {

    if (dataFormModel?.idDeposito <= 0) {
      toast.error('Debe seleccionar el campo Deposito.');
      return false;
    }

    if (dataFormModel?.idProveedorDistribuidor <= 0) {
      toast.error('Debe seleccionar el campo Proveedor.');
      return false;
    }

    if (dataFormModel?.listaFrecuenciaDistribuidorCPs.length <= 0) {
      toast.error('Debe seleccionar el campo Código Postal.');
      return false;
    }

    if (dataFormModel?.costoEntregaInmediata.length <= 0) {
      toast.error('Debe seleccionar el campo Costo entrega inmediata.');
      return false;
    }

    if (dataFormModel?.idFrecuenciaModoDespacho <= 0) {
      toast.error('Debe seleccionar el campo Modo Despacho.');
      return false;
    }

    if (dataFormModel?.rowsFrecuencias.length <= 0) {
      toast.error('Debe agregar al menos una Frecuencia.');
      return false;
    }

    return true;
  };

  const handleClickEdit = (e) => {
    console.log('edit');
    console.log(dataFormModel);
    if (isValidForm()) {
      updateFrecuenciaDistribuidor({
        variables: {
          idFrecuenciaDistribuidor: dataFormModel?.idFrecuenciaDistribuidor,
          idProveedorDistribuidor: dataFormModel?.idProveedorDistribuidor,
          kilometroDestino: parseInt(dataFormModel?.kilometroDestino),
          costoEntregaInmediata: parseFloat(dataFormModel?.costoEntregaInmediata),
          idDeposito: dataFormModel?.idDeposito,
          activo: dataFormModel?.activo,
          idFrecuenciaModoDespacho: dataFormModel?.idFrecuenciaModoDespacho,
          listaFrecuenciaDistribuidorDetalles: dataFormModel?.rowsFrecuencias,
          listaFrecuenciaDistribuidorCPs: dataFormModel?.listaFrecuenciaDistribuidorCPs
        }
      });
    }
  };

  useEffect(() => {
    setChildrenAction(() =>
      <CustomButton
        variant='contained'
        onClick={isNew ? handleClickCreate : handleClickEdit}
        disableElevation
        size='small'>

        {isNew ? 'Crear' : 'Editar'}
      </CustomButton>
    );

  }, [setChildrenAction, setHeaderContent, setFooterContent, dataFormModel]);

  const handleChange = (e) => {
    const { value, name } = e.target;

    setDataFormModel((previousData) => ({
      ...previousData,
      [name]: value
    }));
  };

  const handleToggle = (e) => {
    const { checked, name } = e.target;
    setDataFormModel((previousData) => ({
      ...previousData,
      [name]: checked
    }));
  };

  const handleSearchProveedores = () => {
    setModalProveedorIsOpen(true);
  };

  const handleSearchCodigosPostal = () => {
    setModalCPIsOpen(true);
  };

  const handleRowClickProveedor = (params) => {
    const { row } = params;
    setModalProveedorIsOpen(false);

    setDataFormModel({
      ...dataFormModel,
      idProveedorDistribuidor: row.idProveedorDistribuidor
    });
    setDataFormProveedor({
      ...dataFormProveedor,
      codigoSAP: row.codigoSAP
    });
  };

  const handleRowClickCP = (params) => {
    const { row } = params;
    setModalCPIsOpen(false);

    console.log(codigosPostal);
    console.log(row);

    let listaCP = codigosPostal.filter((x) => x.cP == row.codigoPostal).map((item) => {
      let objeto = {
        idFrecuenciaDistribuidor: 0,
        idFrecuenciaDistribuidorCP: 0,
        idCodigoPostal: item.idCodigoPostal
      };

      return objeto;
    });

    console.log(listaCP);

    setDataFormModel({
      ...dataFormModel,
      listaFrecuenciaDistribuidorCPs: listaCP
    });

    setDataFormCP({
      ...dataFormCP,
      idTipoZona: row.idTipoZona,
      cp: row.codigoPostal,
      provincia: row.provincia,
      localidad: row.localidad
    });

  };
  const initialColumns = [
    {
      headerName: '',
      field: 'action',
      flex: 0.02,
      renderCell: (cellProps) => {
        const { row } = cellProps;
        return (
          <>
            <PopoverModal>
              <div className='popover-modal-content'>
                <div aria-hidden='true' onClick={() => handleEditFrecuencia(row)}
                  className='item-option clickable-option'>

                  <EditIcon className='edit-icon' />
                  <span className='toggle-action'>Editar</span>
                </div>
                <div aria-hidden='true' onClick={() => handleDeleteFrecuencia(row)}
                  className='item-option'>

                  <DeleteIcon className='edit-icon' />
                  <span className='toggle-action'>Eliminar</span>
                </div>
              </div>
            </PopoverModal>
          </>);

      }
    },
    {
      field: 'modalidad',
      headerName: 'Modalidad',
      renderCell: (cellProps) => {
        const { row } = cellProps;
        const renderChips = Object.entries(row)?.map(([key, value], index) => {
          if (Boolean(value)) {
            switch (key) {
              case 'metodoCobroBulto': {
                return <Chip key={index} label='Bulto' />;
              }
              case 'metodoCobroKilo': {
                return <Chip key={index} label='Kilo' />;
              }
              case 'metodoCobroKm': {
                return <Chip key={index} label='Km' />;
              }
              default:
                return null;
            }
          }
        });

        return renderChips;
      }
    },
    {
      field: 'numeroDia',
      headerName: 'Dia',
      renderCell: (cellProps) => {
        const { row } = cellProps;
        const renderChips = Object.entries(row)?.map(([key, value], index) => {
          if (key == 'listaFrecuenciaDistribuidorDetalleDias' && value.length > 0) {
            return procesarDias(value);
          }
        });

        return renderChips;
      }
    },
    {
      field: 'horaSalida',
      headerName: 'Hora de despacho'
    },
    {
      field: 'demoraHoraDestino',
      headerName: 'Demora'
    }];


  const columns = useMemo(() => generateColumnsDefaultConfiguration(initialColumns), []);

  const procesarDias = (lista) => {
    const renderDias = lista.map((item) => {
      return <Chip key={item.numeroDia} label={item.numeroDia} />;
    });

    return renderDias;
  };

  const handleAddFrecuencia = () => {

    if (dataFormModel.idFrecuenciaModoDespacho <= 0) {
      toast.error('Debe seleccionar el campo Modo Despacho.');
      return false;
    }

    setIsNewModalidad(true);
    setModalidadIsOpen(true);
    setEditRow({});
  };

  const handleEditFrecuencia = (row) => {
    console.log('editando...');
    console.log(row);
    setIsNewModalidad(false);
    setModalidadIsOpen(true);
    setEditRow(row);
  };

  const handleDeleteFrecuencia = (row) => {
    setDataFormModel((previousData) => ({
      ...previousData,
      rowsFrecuencias: [...previousData.rowsFrecuencias.filter((x) => x.idFrecuenciaDistribuidorDetalle !== row.idFrecuenciaDistribuidorDetalle)]
    }));
  };

  return (
    <>
      <div className='frecuencia-distribuidor-creation-content'>
        <Grid
          container
          justifyContent={'space-between'}
          columns={{
            xs: 2,
            md: 8
          }}
          marginBottom={2}
          spacing={1}>

          <Grid size={{ xs: 1.7 }}>
            <SelectInput
              options={depositos}
              label='Deposito'
              onChange={handleChange}
              value={dataFormModel?.idDeposito}
              name='idDeposito' />

          </Grid>
          <Grid size={{ xs: 1.7 }}>
            <TextInput
              label='Buscador'
              searchIcon
              placeholder='Buscador'
              name='codigoSAP'
              onClick={isNew ? handleSearchProveedores : () => { }}
              value={dataFormProveedor?.codigoSAP}
              disabled={!isNew} />

          </Grid>
          <Grid size={{ xs: 1.7 }}>
            <TextInput
              label='Buscador'
              searchIcon
              placeholder='Buscador'
              name='cp'
              onClick={handleSearchCodigosPostal}
              value={dataFormCP?.cp} />

          </Grid>
          <Grid size={{ xs: 1.7 }}>
            <TextInput
              label='Costo entrega'
              placeholder='Agregar valor'
              type='number'
              name='costoEntregaInmediata'
              value={dataFormModel?.costoEntregaInmediata}
              onChange={handleChange} />

          </Grid>
          <Grid className='switch-flex-end' size={{ xs: 1.2 }}>
            <div className='switch-row'>
              <span className='span-row'>Activo</span>
              <SwitchInput
                onChange={handleToggle}
                name='activo'
                checked={dataFormModel?.activo} />

            </div>
          </Grid>
        </Grid>
        <Grid
          container
          justifyContent={'space-between'}
          columns={{
            xs: 2,
            md: 8
          }}
          marginBottom={2}
          spacing={1}>

          <Grid size={{ xs: 1.7 }}>
            <TextInput
              label='Localidad'
              placeholder='Localidad'
              name='localidad'
              value={dataFormCP?.localidad}
              disabled />

          </Grid>
          <Grid size={{ xs: 1.7 }}>
            <TextInput
              label='Provincia'
              placeholder='Provincia'
              name='provincia'
              value={dataFormCP?.provincia}
              disabled />

          </Grid>
          <Grid size={{ xs: 1.5 }}>
            <SelectInput
              options={tiposZona}
              label='Tipo Zona'
              value={dataFormCP?.idTipoZona}
              name='idTipoZona'
              disabled />

          </Grid>
          <Grid size={{ xs: 1.7 }}>
            <TextInput
              label='Kilometro Destino'
              placeholder='Kilometro Destino'
              type='number'
              name='kilometroDestino'
              value={dataFormModel?.kilometroDestino}
              onChange={handleChange} />

          </Grid>
          <Grid size={{ xs: 1.3 }}>
            <SelectInput
              options={modosDespacho}
              label='Modo Despacho'
              value={dataFormModel?.idFrecuenciaModoDespacho}
              name='idFrecuenciaModoDespacho'
              onChange={handleChange}
              disabled={dataFormModel?.rowsFrecuencias.length > 0} />

          </Grid>
        </Grid>
        <Grid
          container
          justifyContent={'space-between'}
          columns={{
            xs: 2,
            md: 8
          }}
          marginTop={2}
          className='grid-modalidad'>

          <Grid size={{ xs: 8 }}>
            {dataFormModel?.rowsFrecuencias?.length == 0 &&
              <div className='empty-grid'>
                <img className='empty-grid-svg' src={EmptyGridSvg} width="100%"></img>
                <p>No se ha agregado ninguna frecuencia</p>
                <CustomButton
                  variant='contained'
                  onClick={handleAddFrecuencia}
                  disableElevation
                  size='small'>

                  Agregar
                </CustomButton>
              </div>
            }
            {dataFormModel?.rowsFrecuencias?.length > 0 &&
              <>
                <div className='custom-button'>
                  <CustomButton
                    variant='contained'
                    onClick={handleAddFrecuencia}
                    disableElevation
                    size='small'>

                    Agregar
                  </CustomButton>
                </div>

                <DataGridGenerico
                  className='data-grid'
                  columns={columns}
                  rows={dataFormModel.rowsFrecuencias}
                  toolbar={false} />

              </>
            }
          </Grid>
        </Grid>
      </div>

      <FrecuenciaDetalleModal
        open={modalidadIsOpen}
        onClose={() => setModalidadIsOpen(false)}
        dataFormModel={dataFormModel}
        setDataFormModel={setDataFormModel}
        isNew={isNewModalidad}
        editRow={editRow} />


      <BuscarProveedor
        open={modalProveedorIsOpen}
        onRowClick={handleRowClickProveedor}
        onClose={() => setModalProveedorIsOpen(false)} />


      <BuscarCodigoPostal
        open={modalCPIsOpen}
        onRowClick={handleRowClickCP}
        onClose={() => setModalCPIsOpen(false)} />


    </>);

};